
import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export const registerForm = async (formData) => {
    try {
      const response = await axiosInstance.post("/auth/register", {
        ...formData
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const errorMessage = error.response.data?.error || error?.message;
        if (errorMessage) toast.error(errorMessage);
        else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
        
      } else {
        // خطاهای مربوط به شبکه یا سرور
        toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      }
    }
  };
 
  
  // ویرایش اطلاعات
  export const updateUserInfo = async ({formData,accessToken}) => {
    try {
      const response = await axiosInstance.patch("/user/@me/edit", {
        ...formData
      },{
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const errorMessage = error.response.data?.error || error?.message;
        if (errorMessage) toast.error(errorMessage);
        else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
        
      } else {
        // خطاهای مربوط به شبکه یا سرور
        toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      }
    }
  };
  